import baustein from "baustein";
import template from "templates/modules/search_summary_bar.jinja";

/**
 *
 */
export default baustein.register("search-summary-bar", {
    template: template,
});
